import { FeatureFlagType } from '../../enums/feature-flag-type';

export function hasRequiredFeatureFlag(
  requiredFlags: FeatureFlagType[],
  userFlags: FeatureFlagType[]
): boolean {
  if (!requiredFlags || requiredFlags.length === 0) return true;
  return requiredFlags.some(flag => userFlags.includes(flag));
}